import React, { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const ProtectedRoute = ({ children, adminRequired = true }) => {
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = () => {
      // Récupération des informations d'authentification
      const token = localStorage.getItem("token");
      const isAdmin = localStorage.getItem("isAdmin") === "true";

      // Log pour déboguer
      console.log("ProtectedRoute check:", {
        token: !!token,
        isAdmin,
        adminRequired,
        path: window.location.pathname,
      });

      // Vérifie si l'utilisateur est connecté
      if (!token) {
        toast.error("Vous devez être connecté pour accéder à cette page");
        setIsAuthorized(false);
        setIsLoading(false);
        return;
      }

      // Vérifie les droits d'admin si nécessaire
      if (adminRequired && !isAdmin) {
        toast.error(
          "Accès non autorisé. Cette page est réservée aux administrateurs."
        );
        setIsAuthorized(false);
        setIsLoading(false);
        return;
      }

      // Vérifie si le token est expiré
      try {
        const payload = JSON.parse(
          atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/"))
        );

        const isExpired = payload.exp * 1000 < Date.now();

        if (isExpired) {
          localStorage.removeItem("token");
          localStorage.removeItem("isAdmin");
          localStorage.removeItem("userName");
          localStorage.removeItem("profilePicture"); // Ajout pour l'image de profil Google
          toast.error("Votre session a expiré. Veuillez vous reconnecter.");
          setIsAuthorized(false);
        } else {
          // Si l'utilisateur est connecté et que le token est valide
          // Et si adminRequired est false OU si l'utilisateur est admin
          setIsAuthorized(true);
        }
      } catch (error) {
        console.error("Erreur lors du décodage du token:", error);

        // En cas de problème avec le décodage, on considère que le token est invalide
        localStorage.removeItem("token");
        localStorage.removeItem("isAdmin");
        localStorage.removeItem("userName");
        localStorage.removeItem("profilePicture"); // Ajout pour l'image de profil Google
        toast.error("Problème d'authentification. Veuillez vous reconnecter.");
        setIsAuthorized(false);
      }

      setIsLoading(false);
    };

    checkAuth();
  }, [adminRequired, navigate]);

  // Ajout d'une vérification périodique de l'expiration du token
  useEffect(() => {
    const interval = setInterval(() => {
      const token = localStorage.getItem("token");
      if (token) {
        try {
          const payload = JSON.parse(
            atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/"))
          );

          const isExpired = payload.exp * 1000 < Date.now();

          if (isExpired) {
            localStorage.removeItem("token");
            localStorage.removeItem("isAdmin");
            localStorage.removeItem("userName");
            localStorage.removeItem("profilePicture"); // Ajout pour l'image de profil Google
            toast.error("Votre session a expiré. Veuillez vous reconnecter.");
            setIsAuthorized(false);
            navigate("/login");
          }
        } catch (error) {
          console.error("Erreur lors de la vérification du token:", error);
          // En cas d'erreur, on ne fait rien pour éviter une redirection en boucle
        }
      }
    }, 60000); // Vérification toutes les minutes

    return () => clearInterval(interval);
  }, [navigate]);

  if (isLoading) {
    return (
      <div className="text-center p-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Chargement...</span>
        </div>
        <p className="mt-2">Vérification de l'authentification...</p>
      </div>
    );
  }

  if (!isAuthorized) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
